import { getAllowActionByCurrRole } from "@/utils/get-roles";
const INIT_FILTER_VALUE = {
  national_id: null,
  full_name: null,
  address: {
    amphur: null,
    province: null,
    tumbol: null,
    village: null,
  },
  age_rage_selected: [],
  gender: null,
  is_household_head: null,
  is_family_head: null,
  is_handicapped: null,
  problems: [],
  benefits: [],
  educations: [],
  primary_occupations: [],
  patients: [],
  age_rage: {
    start: null,
    end: null,
  },
  volunteer: localStorage.getItem("volunteerData")
    ? JSON.parse(localStorage.getItem("volunteerData"))
    : null,
  advance_filter: false,
  cm_uid: null,
};

const state = () => {
  return { ...INIT_FILTER_VALUE };
};

// actions
const actions = {
  clearStore({ commit }) {
    commit("clearStore");
  },
  setStore({ commit }, store) {
    commit("setStore", store);
  },
  // START: national_id
  setNationalId({ commit }, national_id) {
    commit("setNationalId", national_id);
  },
  // END: national_id
  // START: fullName
  setFullName({ commit }, full_name) {
    commit("setFullName", full_name);
  },
  // END: fullName
  //   START: address
  setAddress({ commit }, address) {
    commit("setAddress", address);
  },
  setAmphur({ commit }, amphur) {
    commit("setAmphur", amphur);
  },
  setProvince({ commit }, province) {
    commit("setProvince", province);
  },
  setTumbol({ commit }, tumbol) {
    commit("setProvince", tumbol);
  },
  setVillage({ commit }, village) {
    commit("setVillage", village);
  },
  //   END: address
  //   START: age_rage_selected
  appendAgeRageSelected({ commit }, age_rage_selected) {
    commit("appendAgeRageSelected", age_rage_selected);
  },
  removeAgeRageSelected({ commit }, age_rage_selected) {
    commit("removeAgeRageSelected", age_rage_selected);
  },
  setAgeRageSelected({ commit }, age_rage_selectedes) {
    commit("setAgeRageSelected", age_rage_selectedes);
  },
  // END: age_rage_selected
  //   START: gender
  setGender({ commit }, gender) {
    commit("setGender", gender);
  },
  toggleGender({ commit }) {
    commit("toggleGender");
  },
  // END: gender
  //   START: is_household_head
  setIsHouseholdHead({ commit }, boo) {
    commit("setIsHouseholdHead", boo);
  },
  toggleIsHouseholdHead({ commit }) {
    commit("toggleIsHouseholdHead");
  },
  // END: is_household_head
  //   START: is_family_head
  setIsFamilyHead({ commit }, boo) {
    commit("setIsFamilyHead", boo);
  },
  toggleIsFamilyHead({ commit }) {
    commit("toggleIsFamilyHead");
  },
  // END: is_family_head
  //   START: is_handicapped
  setIsHandicapped({ commit }, boo) {
    commit("setIsHandicapped", boo);
  },
  toggleIsHandicapped({ commit }) {
    commit("toggleIsHandicapped");
  },
  // END: is_handicapped
  // START: problems
  appendProblem({ commit }, problem) {
    commit("appendProblem", problem);
  },
  removeProblem({ commit }, problem) {
    commit("removeProblem", problem);
  },
  setProblems({ commit }, problems) {
    commit("setProblems", problems);
  },
  //   END: problems
  //   START: benefits
  appendBenefit({ commit }, benefit) {
    commit("appendBenefit", benefit);
  },
  removeBenefit({ commit }, benefit) {
    commit("removeBenefit", benefit);
  },
  setBenefits({ commit }, benefits) {
    commit("setBenefits", benefits);
  },
  // END: benefits
  //   START: educations
  appendEducation({ commit }, education) {
    commit("appendEducation", education);
  },
  removeEducation({ commit }, education) {
    commit("removeEducation", education);
  },
  setEducations({ commit }, educations) {
    commit("setEducations", educations);
  },
  // END: educations
  // START: primary_occupations
  appendPrimaryOccupation({ commit }, primary_occupation) {
    commit("appendPrimaryOccupation", primary_occupation);
  },
  removePrimaryOccupation({ commit }, primary_occupation) {
    commit("removePrimaryOccupation", primary_occupation);
  },
  setPrimaryOccupations({ commit }, primary_occupations) {
    commit("setPrimaryOccupations", primary_occupations);
  },
  // END: primary_occupations
  // START: patients
  appendPatient({ commit }, patient) {
    commit("appendPatient", patient);
  },
  removePatient({ commit }, patient) {
    commit("removePatient", patient);
  },
  setPatients({ commit }, patients) {
    commit("setPatients", patients);
  },
  // END: patients
  // START: age_rage
  setAgeRage({ commit }, age_rage) {
    commit("setAgeRage", age_rage);
  },
  setAgeRageStart({ commit }, start) {
    commit("setAgeRageStart", start);
  },
  setAgeRageEnd({ commit }, end) {
    commit("setAgeRageEnd", end);
  },
  // END: age_rage
  //   START: volunteer
  setVolunteer({ commit }, volunteer) {
    commit("setVolunteer", volunteer);
  },
  // END: volunteer
  //   START: advanceFilter
  setAdvanceFilter({ commit }, boo) {
    commit("setAdvanceFilter", boo);
  },
  toggleAdvanceFilter({ commit }) {
    commit("toggleAdvanceFilter");
  },
  //   END: advanceFilter
  // START: cm
  setCM({ commit }, cm_uid) {
    commit("setCM", cm_uid);
  },
  // END: cm
};

// mutations
const mutations = {
  // START: cm
  setCM(state, cm_uid) {
    state.cm_uid = cm_uid;
  },
  // END: cm
  clearStore(state) {
    state = { ...INIT_FILTER_VALUE };
  },
  setStore(state, store) {
    Object.assign(state, store);
  },
  // START: national_id
  setNationalId(state, national_id) {
    state.national_id = national_id;
  },
  // END: national_id
  // START: fullName
  setFullName(state, full_name) {
    state.full_name = full_name;
  },
  // END: fullName
  //   START: address
  setAddress(state, address) {
    state.address = address;
  },
  setProvince(state, province) {
    state.address.province = province;
  },
  setAmphur(state, amphur) {
    state.address.amphur = amphur;
  },
  setTumbol(state, tumbol) {
    state.address.tumbol = tumbol;
  },
  setVillage(state, village) {
    state.address.village = village;
  },
  //   END: address
  //   START: age_rage_selected
  appendAgeRageSelected(state, age_rage_selected) {
    state.age_rage_selected.push(age_rage_selected);
  },
  removeAgeRageSelected(state, age_rage_selected) {
    state.age_rage_selected = state.age_rage_selected.filter(
      (type) => type !== age_rage_selected
    );
  },
  setAgeRageSelected(state, age_rage_selectedes) {
    state.age_rage_selected = age_rage_selectedes;
  },
  // END: age_rage_selected
  //   START: gender
  setGender(state, gender) {
    state.gender = gender;
  },
  toggleGender(state) {
    if (state.gender === "male") state.gender = "female";
    else state.gender = "male";
  },
  // END: gender
  //   START: is_household_head
  setIsHouseholdHead(state, boo) {
    state.is_household_head = boo;
  },
  toggleIsHouseholdHead(state) {
    state.is_household_head = !state.is_household_head;
  },
  // END: is_household_head
  //   START: is_family_head
  setIsFamilyHead(state, boo) {
    state.is_family_head = boo;
  },
  toggleIsFamilyHead(state) {
    state.is_family_head = !state.is_family_head;
  },
  // END: is_family_head
  // START: is_handicapped
  setIsHandicapped(state, boo) {
    state.is_handicapped = boo;
  },
  toggleIsHandicapped(state) {
    state.is_handicapped = !state.is_handicapped;
  },
  // END: is_handicapped
  // START: problems
  appendProblem(state, problem) {
    state.problems.push(problem);
  },
  removeProblem(state, problem) {
    state.problems = state.problems.filter((type) => type !== problem);
  },
  setProblems(state, problems) {
    state.problems = problems;
  },
  //   END: problems
  //   START: benefits
  appendBenefit(state, benefit) {
    state.benefits.push(benefit);
  },
  removeBenefit(state, benefit) {
    state.benefits = state.benefits.filter((type) => type !== benefit);
  },
  setBenefits(state, benefits) {
    state.benefits = benefits;
  },
  // END: benefits
  //   START: educations
  appendEducation(state, education) {
    state.educations.push(education);
  },
  removeEducation(state, education) {
    state.educations = state.educations.filter((type) => type !== education);
  },
  setEducations(state, educations) {
    state.educations = educations;
  },
  // END: educations
  // START: primary_occupations
  appendPrimaryOccupation(state, primary_occupation) {
    state.primary_occupations.push(primary_occupation);
  },
  removePrimaryOccupation(state, primary_occupation) {
    state.primary_occupations = state.primary_occupations.filter(
      (type) => type !== primary_occupation
    );
  },
  setPrimaryOccupations(state, primary_occupations) {
    state.primary_occupations = primary_occupations;
  },
  // END: primary_occupations
  // START: patients
  appendPatient(state, patient) {
    state.patients.push(patient);
  },
  removePatient(state, patient) {
    state.patients = state.patients.filter((type) => type !== patient);
  },
  setPatients(state, patients) {
    state.patients = patients;
  },
  // END: patients
  // START: age_rage
  setAgeRage(state, age_rage) {
    state.age_rage = age_rage;
  },
  setAgeRageStart(state, start) {
    state.age_rage.start = start;
  },
  setAgeRageEnd(state, end) {
    state.age_rage.end = end;
  },
  // END: age_rage
  //   START: volunteer
  setVolunteer(state, volunteer) {
    state.volunteer = volunteer;
  },
  // END: volunteer
  //   START: advance_filter
  setAdvanceFilter(state, boo) {
    state.advance_filter = boo;
  },
  toggleAdvanceFilter(state) {
    state.advance_filter = !state.advance_filter;
  },
  //   END: advance_filter
};

// getters
const getters = {
  national_id: (state) => state.national_id,
  full_name: (state) => state.full_name,
  address: (state) => state.address,
  amphur: (state) => state.address.amphur,
  province: (state) => state.address.province,
  tumbol: (state) => state.address.tumbol,
  village: (state) => state.village,
  age_rage_selected: (state) => state.age_rage_selected,
  gender: (state) => state.gender,
  is_household_head: (state) => state.is_household_head,
  is_family_head: (state) => state.is_family_head,
  is_handicapped: (state) => state.is_handicapped,
  problems: (state) => state.problems,
  benefits: (state) => state.benefits,
  educations: (state) => state.educations,
  primary_occupations: (state) => state.primary_occupations,
  patients: (state) => state.patients,
  age_rage: (state) => state.age_rage,
  age_rage_start: (state) => state.age_rage.start,
  age_rage_end: (state) => state.age_rage.end,
  volunteer: (state) => state.volunteer,
  getAllFilter: (state) => {
    if (state.advance_filter) return state;
    const commonFilter = {
      ...state,
      age_rage_selected: [],
      gender: null,
      is_household_head: null,
      is_family_head: null,
      is_handicapped: null,
      problems: [],
      benefits: [],
      educations: [],
      primary_occupations: [],
      patients: [],
      age_rage: {
        start: null,
        end: null,
      },
      volunteer: null,
      advance_filter: false,
    };
    if (localStorage.getItem("volunteerData")) {
      commonFilter.volunteer = JSON.parse(
        localStorage.getItem("volunteerData")
      );
    }
    return commonFilter;
  },
  getCommonFilter: (state) => {
    const commonFilter = {
      address: {
        amphur: state.address.amphur,
        province: state.address.province,
        tumbol: state.address.tumbol,
        village: state.address.village,
      },
      national_id: state.national_id,
      full_name: state.full_name,
    };
    return commonFilter;
  },
  getFilterSummaryArray: (state, getters, rootState, rootGetters) => {
    let prepareState = { ...state };
    if (!prepareState.advance_filter) {
      prepareState = {
        ...prepareState,
        age_rage_selected: [],
        gender: null,
        is_household_head: null,
        is_family_head: null,
        is_handicapped: null,
        problems: [],
        benefits: [],
        educations: [],
        primary_occupations: [],
        patients: [],
        age_rage: {
          start: null,
          end: null,
        },
        volunteer: null,
      };
    }

    let result = [];

    // national_id
    if (prepareState.national_id)
      result.push({
        title: "เลขบัตรประชาชน",
        text: prepareState.national_id,
      });
    // full_name
    if (prepareState.full_name)
      result.push({
        title: "ชื่อ - นามสกุล",
        text: prepareState.full_name,
      });
    // address
    if (prepareState.address.province || getAllowActionByCurrRole("default-provinceCode-search"))
      result.push({
        title: "จังหวัด",
        text: prepareState.address.province ? prepareState.address.province.province_name : rootGetters["userAuth/getTokenParsed"]['provinceName'],
      });
    if (prepareState.address.amphur)
      result.push({
        title: "อำเภอ/เขต",
        text: prepareState.address.amphur.amphur_name,
      });
    if (prepareState.address.tumbol)
      result.push({
        title: "ตำบล/แขวง",
        text: prepareState.address.tumbol.tumbol_name,
      });
    if (prepareState.address.village)
      result.push({
        title: "หมู่บ้าน",
        text: prepareState.address.village.village_name,
      });
    if (prepareState.age_rage_selected.length > 0)
      result.push({
        title: "สภาพปัญหา",
        text: prepareState.age_rage_selected.join(", "),
      });
    if (prepareState.gender)
      result.push({
        title: "เพศ",
        text: prepareState.gender,
      });
    if (prepareState.is_household_head)
      result.push({
        title: "หัวหน้าครัวเรือน",
        text: prepareState.is_household_head,
      });
    if (prepareState.is_family_head)
      result.push({
        title: "หัวหน้าครอบครัว",
        text: prepareState.is_family_head,
      });
    if (prepareState.is_handicapped)
      result.push({
        title: "ผู้พิการ",
        text: prepareState.is_handicapped,
      });
    if (prepareState.problems.length > 0)
      result.push({
        title: "สภาพปัญหา",
        text: prepareState.problems.join(", "),
      });
    if (prepareState.benefits.length > 0)
      result.push({
        title: "สวัสดิการ",
        text: prepareState.benefits.join(", "),
      });
    if (prepareState.educations.length > 0)
      result.push({
        title: "การศึกษา",
        text: prepareState.educations.map((item) => item.desc).join(", "),
      });
    if (prepareState.primary_occupations.length > 0)
      result.push({
        title: "อาชีพหลัก",
        text: prepareState.primary_occupations
          .map((item) => item.desc)
          .join(", "),
      });
    if (prepareState.patients.length > 0)
      result.push({
        title: "ผู้ป่วย",
        text: prepareState.patients.map((item) => item.desc).join(", "),
      });

    if (
      typeof prepareState.age_rage.start === "number" &&
      prepareState.age_rage.end
    ) {
      result.push({
        title: "ช่วงอายุ",
        text: `${prepareState.age_rage.start} - ${prepareState.age_rage.end}`,
      });
    } else if (prepareState.age_rage.start) {
      result.push({
        title: "ช่วงอายุ",
        text: `${prepareState.age_rage.start} ขึ้นไป`,
      });
    } else if (prepareState.age_rage.end) {
      result.push({
        title: "ช่วงอายุ",
        text: `น้อยกว่า ${prepareState.age_rage.end}`,
      });
    }

    if (prepareState.volunteer)
      result.push({
        title: "อพม.",
        text: `${prepareState.volunteer.title}${prepareState.volunteer.name} ${prepareState.volunteer.surname}`,
      });

    return result;
  },
  getFilterForApi: (state, getters, rootState, rootGetters) => {
    const result = {};
    // if (state.address.province)
    //action include default-provinceCode-search send provCode for default
    if (
      getAllowActionByCurrRole("default-provinceCode-search") ||
      state.address.province
    ) {
      result.prov = state.address.province
        ? state.address.province._id.province_ID.toString()
        : rootGetters["userAuth/getTokenParsed"]["provinceCode"].toString();
    }
    if (state.address.amphur)
      result.amp = state.address.amphur._id.amphur_ID.toString();
    if (state.address.tumbol)
      result.tam = state.address.tumbol._id.tumbol_ID.toString();
    if (state.address.village)
      result.vil = state.address.village._id.village_ID.toString();
    if (state.full_name) result.member_name = state.full_name;
    if (state.national_id) result.member_nid = state.national_id;

    if (state.advance_filter) {
      if (state.gender) result.gender = state.gender;
      if (state.age_rage_selected.length > 0)
        result.ageclass = state.age_rage_selected;
      if (state.is_household_head)
        result.hh_head = state.is_household_head === "ใช่" ? 1 : 0;
      if (state.is_family_head)
        result.fam_head = state.is_family_head === "ใช่" ? 1 : 0;
      if (state.is_handicapped)
        result.disabled = state.is_handicapped === "ใช่" ? 1 : 0;
      if (state.educations.length > 0)
        result.education = state.educations.map((item) => item.code);
      if (state.primary_occupations.length > 0)
        result.occupation = state.primary_occupations.map((item) => item.code);
      if (state.problems.length > 0) {
        for (const index in state.problems) {
          const value = state.problems[index];
          if (value === "ปัญหาด้านสุขภาพ") result.prob_health = 1;
          if (value === "ปัญหาด้านครัวเรือน") result.prob_family = 1;
          if (value === "ปัญหาด้านการศึกษา") result.prob_education = 1;
          if (value === "ปัญหาด้านการเงิน") result.prob_occupation = 1;
          if (value === "ปัญหาด้านการเข้าถึงสิทธิ")
            result.prob_accessibility = 1;
        }
      }
      if (state.age_rage.start || state.age_rage.end) {
        result.agerange = `[${
          state.age_rage.start ? state.age_rage.start : ""
        },${state.age_rage.end ? state.age_rage.end : ""}]`;
      }
      if (state.patients.length > 0)
        result.patient_status = state.patients.map((item) => item.code);
      if (state.volunteer) result.volunteer_id = state.volunteer.national_id;
    }
    //if vt role send volunteer for default
    if (rootGetters["userAuth/getUserRoleCode"] === "vt") {
      if (state.volunteer) result.volunteer_id = state.volunteer.national_id;
    }
    // if (state.cm_uid) result.cm_uid = state.cm_uid;
    //if action include default-cm_uid-search send cm_uid for default
    if (getAllowActionByCurrRole("default-cm_uid-search")) {
      result.cm_uid = state.cm_uid
        ? state.cm_uid
        : rootGetters["userAuth/getUsername"];
    }
    return result;
  },

  // {
  //   //   not require
  //   "amp": "222",  // UI มีแต่ request ไม่มี ✅
  //   "tam": "1234", // UI มีแต่ request ไม่มี ✅
  //   "village": "12345", // UI มีแต่ request ไม่มี ✅
  //   "member_name": "ใจ เอื้ออารี", ✅
  //   "national_id": "1234567890123", ✅
  //   "gender": "male", ✅
  //   "agerange": "[1,1]", ✅
  //   "ageclass": ["เด็ก", "ผู้ใหญ่"], ✅
  //   "hh_head": true, // เปลี่ยน 0 1 เป็น true false แต่ไม่ต้องก็ได้ ✅
  //   "fam_head": true, ✅
  //   "disabled": true, ✅
  //   "education": ["code"], // ui เลือกได้หลายอันเปลี่ยนเป็น array ✅
  //   "occupation": ["code"], // ui เลือกได้หลายอันเปลี่ยนเป็น array ✅
  //   "prob_housing": true,
  //   "prob_health": true, ✅
  //   "prob_education": true, ✅
  //   "prob_occupation": true, ✅
  //   "prob_family": true, ✅
  //   "prob_violence": true,
  //   "prob_human_trafficking": true,
  //   "prob_accessibility": true, ✅
  //   "prob_others": true,
  //   "patient": ["ผู้ป่วยเริ้อรัง", "ผู้ป่วยติดเตียง", "ผู้ป่วยร้ายแรง"] // เพื่มการ filter ผู้ป่วย ✅
  // }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
